class BackofficeAppController extends AbstractController
	@register()
	@inject '$rootScope', '$scope'

	initialize: ->
		@$scope.isSideMenuHidden = true
		@$rootScope.hideMenu = true
